import React from 'react';
import ImageWithDescContainer from '../../Componant/Gallery/ImageWithDesc';

const ImageWithDesc = () => {
  return (
    <div className='page-body'>
      <ImageWithDescContainer />
    </div>
  );
};

export default ImageWithDesc;
